<script>

  import vSelect from 'vue-select'

  export default {
    extends: vSelect,
    watch:{
      options (newValue) {

        let newOptions = JSON.stringify(newValue)

        if(this.multiple){

          let filteredValue = this.value.filter((option) => newOptions.includes(JSON.stringify(option)))

          if(filteredValue.length != this.value.length){
            this.$emit('input', filteredValue)
          }

        }else{

          if(!newOptions.includes(JSON.stringify(this.value))){
            this.$emit('input', null)
          }

        }
        
      },
    }
  }
  </script>

  